"use client";

import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTagContext } from "./3XAVFTCA.js";
import { useCompositeStoreOptions, useCompositeStoreProps } from "./4CMBR7SL.js";
import { usePopoverStoreProps } from "./O2PQ2652.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";
import { useUpdateEffect } from "./ABQUS43J.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js"; // src/combobox/combobox-store.ts

import * as Core from "@ariakit/core/combobox/combobox-store";

function useComboboxStoreOptions(props) {
  var tag = useTagContext();
  props = __spreadProps(__spreadValues({}, props), {
    tag: props.tag !== void 0 ? props.tag : tag
  });
  return useCompositeStoreOptions(props);
}

function useComboboxStoreProps(store, update, props) {
  useUpdateEffect(update, [props.tag]);
  useStoreProps(store, props, "value", "setValue");
  useStoreProps(store, props, "selectedValue", "setSelectedValue");
  useStoreProps(store, props, "resetValueOnHide");
  useStoreProps(store, props, "resetValueOnSelect");
  return Object.assign(useCompositeStoreProps(usePopoverStoreProps(store, update, props), update, props), {
    tag: props.tag
  });
}

function useComboboxStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  props = useComboboxStoreOptions(props);

  var _useStore = useStore(Core.createComboboxStore, props),
      _useStore2 = _slicedToArray(_useStore, 2),
      store = _useStore2[0],
      update = _useStore2[1];

  return useComboboxStoreProps(store, update, props);
}

export { useComboboxStoreOptions, useComboboxStoreProps, useComboboxStore };